import React, { useContext, useMemo } from "react";
import PropTypes from "prop-types";

export const PixAndGoContext = React.createContext({});

export default function PixAndGoProvider({ children, config }) {
  const contextValue = useMemo(
    () => ({
      tagline: config?.tagline ?? null,
      merchantLogoUrl: config?.merchantLogoUrl ?? null,
      presets: config?.presets ?? null,
      termsUrl: config?.termsUrl ?? null,
      depositLimits: config?.deposit_limits ?? null,
    }),
    [config],
  );

  return (
    <PixAndGoContext.Provider value={contextValue}>
      {children}
    </PixAndGoContext.Provider>
  );
}

export function usePixAndGoConfig() {
  return useContext(PixAndGoContext);
}

PixAndGoProvider.propTypes = {
  children: PropTypes.node.isRequired,
  config: PropTypes.shape({
    tagline: PropTypes.string,
    merchantLogoUrl: PropTypes.string,
    presets: PropTypes.arrayOf(PropTypes.number),
    termsUrl: PropTypes.string,
    deposit_limits: PropTypes.shape({
      min: PropTypes.number,
      max: PropTypes.number,
    }),
  }),
};

PixAndGoProvider.defaultProps = {
  config: null,
};
